export default __webpack_public_path__ + "static/media/AdminIcon.13b3b978.svg";